import React, { useContext, useEffect, useRef, useState } from 'react';
import JobRequests from './JobRequests';

import { getNextPickupTime, getSelectedTabListPickupView, getSelectedTabListView, getUserData, setNextPickupTime, setSelectedTabListPickupView, setSelectedTabListView } from '../../utils/localStorage';
import { useNavigate } from 'react-router-dom';
import SuccessModal from '../SuccessModal';
import StatusFilterModal from '../StatusFilterModal';
import TabMenu from '../TabMenu';
import StoreMenu from '../StoreMenu';
import { postStoreRiderJobPickupOrDelivery } from '../../services/StoreRiderInfo/StoreRiderInfo';
import ButtonLink from '../../ButtonLink';
import { getStoreNewPick } from '../../services/DashboardAPI/DashboardApi';
import { Toast } from 'primereact/toast';
import PickupNotification from "../../assets/sounds/pickup-notification.mp3"
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import JobRequestsListView from './JobRequestsListView';
import RiderPickupDeliveryOrderBookingModal from '../RiderPickupDeliveryOrderBookingModal';
import { ProgressSpinner } from 'primereact/progressspinner';
import { FloatLabel } from 'primereact/floatlabel';
import { Dropdown } from 'primereact/dropdown';
import { getBrandStore } from '../../services/StoreUsers/PostStoreUsers';
import AdminMenu from '../AdminMenu';
import RiderPickupDeliveryOrderCancelModal from '../RiderPickupDeliveryOrderCancelModal';
import { localeDateEndDate, localeDateStartDate } from '../../constants/DateUtil/DateUtil';
import SupportAdminMenu from '../SupportAdminMenu';

const { innerWidth: width, innerHeight: height } = window;

const PickupJobAdmin = () => {
  const navigate = useNavigate();

  const { userProfileRole, brandProfileData } = getUserData();
  const userRole = userProfileRole;
  let brandId = brandProfileData.id;

  const [assignStoreValue, setAssignStoreValue] = useState("");
  const [storeId, setStoreId] = useState(null);

  const handleAssignStoreChange = (selectedItem) => {
    setAssignStoreValue(selectedItem);
    const data = {
      startDate: localeDateStartDate(new Date(startDate)),
      endDate: localeDateEndDate(new Date(endDate)),
      jobStatus: [
        "ORDER_BOOKED",
        "CANCEL_BY_RIDER",
        "CANCEL_BY_CUSTOMER",
        "CANCEL_BY_STORE",
        'PICKUP_REQ',
        'ASSIGNED_TO_RIDER',
        'RESCHEDULE_BY_CUSTOMER',
        'RESCHEDULE_BY_RIDER',
      ],
      sortOrder: "desc",
            sortBy: "id",
    };
    fetchRiderJobPickupData(data, selectedItem);
    setStoreId(selectedItem);
  };

  const [visible, setVisible] = useState(false);

  const jobType = 'pickup';

  let initialStartDate = new Date();
  initialStartDate.setDate(initialStartDate.getDate() - 30); // subtract 7 days to current date

  const [startDate, setStartDate] = useState(new Date(initialStartDate));

  
    let initialEndDate = new Date();
    initialEndDate.setDate(initialEndDate.getDate() + 30); // subtract 7 days to current date
    const [endDate, setEndDate] = useState(new Date(initialEndDate));

  const [modalVisible, setModalVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false); // New state for loading indicator
  const [isGetJobButtonPressed, setIsGetJobButtonPressed] = useState(false);
  const [statusFilterModalVisible, setStatusFilterModalVisible] =
    useState(false);
  const [upDateSelectedStatus, setUpDateSelectedStatus] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState('ALL');

  const [riderPickupDeliveryOrderBookingModalVisible, setRiderPickupDeliveryOrderBookingModalVisible] = useState(false);
  const [riderPickupDeliveryOrderCancelModalVisible, setRiderPickupDeliveryOrderCancelModalVisible] = useState(false);

  const minimumDate = new Date();
  minimumDate.setMonth(minimumDate.getMonth()); // subtract 3 months to current date

  const maximumDate = new Date();
  maximumDate.setMonth(maximumDate.getMonth() + 3); // Add 3 months to current date

  const [storeData, setStoreData] = useState([]);

  const enabledNewPickupStoreNotified = storeData.enabledNewPickupStoreNotified;

  const [todayOrderData, setTodayOrderData] = useState([]);
  const [orderBookedType, setOrderBookedType] = useState("")

  const [tabularView, setTabularView] = useState(false);

  const handleTabListViewChange = async (selectedType) => {
    setTabularView(selectedType);
    await setSelectedTabListPickupView(selectedType);
  };

  const fetchSelectedTabListView = async () => {
    try {
      const selectedInvoiceTypeData = await getSelectedTabListPickupView();
      setTabularView(selectedInvoiceTypeData?.tabListPickupView || "list");
    } catch {
      setTabularView("list");
    }
  };

  const fetchStoreUser = () => {
    getBrandStore(brandId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          const newRes = Res.map((item) => ({
            name: item.storeName,
            value: item.id,
          }));
          setStoreData(newRes);
          // fetchStoreRiderInfo(Res[0].id);
          // setStoreId(Res[0].id);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const fetchRiderJobPickupData = (data, storeId) => {
    postStoreRiderJobPickupOrDelivery(storeId, jobType, data)
      .then(response => {
        if (!response.data.error) {
          const Res = response.data;
          const FilterData = Res?.filter((item) => item?.pickupRequest?.requestForBooking === false)
          setTodayOrderData(FilterData);
        }
      })
      .catch(err => {
        console.error('Rider Job Error:', err);
      });
  };

  const toast = useRef(null);
  const audioRef = useRef(null);
  const hasNotifiedRef = useRef(false);

  const showInfo = (data) => {
    toast.current?.show({
      severity: "info",
      summary: "Notification",
      detail: `You got a ${data > 1 ? data : ""} new pick up request, please check`,
      life: 10000,
    });

    // 🔊 Play sound
    if (audioRef.current) {
      audioRef.current.currentTime = 0; // restart sound
      audioRef.current.play().catch(() => {
        // autoplay might be blocked until user interaction
      });
    }
  };

  //  useEffect(() => {
  //    const unlockAudio = () => {
  //      if (audioRef.current) {
  //        audioRef.current.play().then(() => {
  //          audioRef.current.pause();
  //          audioRef.current.currentTime = 0;
  //        });
  //      }
  //      document.removeEventListener("click", unlockAudio);
  //    };

  //    document.addEventListener("click", unlockAudio);

  //    return () => document.removeEventListener("click", unlockAudio);
  //  }, []);

  const fetchStoreNewPick = async () => {
    try {
      const response = await getStoreNewPick(storeId);

      if (!response.data.error) {
        if (response.data > 0 && !hasNotifiedRef.current) {
          showInfo(response.data);
          hasNotifiedRef.current = true;
        }

        // reset when no pickup exists
        if (response.data === 0) {
          hasNotifiedRef.current = false;
        }
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (enabledNewPickupStoreNotified) {

      // Initialize timer if not present
      if (!getNextPickupTime()) {
        setNextPickupTime();
      }

      const interval = setInterval(() => {
        const nextTime = getNextPickupTime();
        const now = Date.now();

        if (now >= nextTime) {
          // ⏰ Time is zero → call API
          fetchStoreNewPick();

          // 🔄 Reset timer
          setNextPickupTime();
        }
      }, 1000); // check every second

      return () => clearInterval(interval);
    }
  }, [enabledNewPickupStoreNotified]);

  //  useEffect(() => {
  //    const interval = setInterval(() => {
  //      fetchStoreNewPick();
  //    }, 15000); // 15 seconds

  //    return () => clearInterval(interval);
  //  }, []);


  useEffect(() => {
    fetchStoreUser();
    fetchSelectedTabListView();
  }, []);

  const callRequestApi = () => {
    const data = {
      startDate: localeDateStartDate(new Date(startDate)),
      endDate: localeDateEndDate(new Date(endDate)),
      jobStatus: [
        "ORDER_BOOKED",
        "CANCEL_BY_RIDER",
        "CANCEL_BY_CUSTOMER",
        "CANCEL_BY_STORE",
        'PICKUP_REQ',
        'ASSIGNED_TO_RIDER',
        'RESCHEDULE_BY_CUSTOMER',
        'RESCHEDULE_BY_RIDER',
      ],
      sortOrder: "desc",
            sortBy: "id",
    };
    fetchRiderJobPickupData(data, storeId);
    fetchSelectedTabListView();
  };


  const handleFilterModal = () => {
    setStatusFilterModalVisible(true);
    // Close the filter modal or perform any other necessary actions
  };

  const handleFilterOrderBookedModal = () => {
    setRiderPickupDeliveryOrderBookingModalVisible(true);
    // Close the filter modal or perform any other necessary actions
  };


  const handleFilterOrderCancelModal = () => {
    setRiderPickupDeliveryOrderCancelModalVisible(true);
    // Close the filter modal or perform any other necessary actions
  };


  const receiveDataFromStatusFilterModal = selectedStatus => {
    handleConfirmPickup(selectedStatus)
  };

  const receiveDataFromOrderBookedFilterModal = newSchedular => {
    handleConfirmPickup(newSchedular)
    setOrderBookedType("ORDER_BOOKED")
  };

  const receiveDataFromOrderCancelFilterModal = newSchedular => {
    handleConfirmPickup(newSchedular)
    setOrderBookedType("ORDER_CANCEL")
  };

  const handleConfirmPickup = (selectedStatus) => {
    // Create a new pickup request object
    setIsLoading(true);

    if (!isGetJobButtonPressed) {
      // Set the state to indicate that the button has been pressed
      setIsGetJobButtonPressed(true);
      setTimeout(() => {
        setIsLoading(false);

        const data1 = {
          startDate: localeDateStartDate(new Date(selectedStatus?.newSchedular?.startDate)) || localeDateStartDate(new Date(startDate)),
          endDate: localeDateEndDate(new Date(selectedStatus?.newSchedular?.endDate)) || localeDateEndDate(new Date(endDate)),
          jobStatus: [selectedStatus?.newSchedular?.selectedStatus],
          sortOrder: "desc",
                sortBy: "id",
        };

        const data2 = {
          startDate: localeDateStartDate(new Date(startDate)),
          endDate: localeDateEndDate(new Date(endDate)),
          jobStatus:
            selectedStatus !== 'ALL'
              ? selectedStatus
              : [
                "ORDER_BOOKED",
                "CANCEL_BY_RIDER",
        "CANCEL_BY_CUSTOMER",
        "CANCEL_BY_STORE",
                'PICKUP_REQ',
                'ASSIGNED_TO_RIDER',
                'RESCHEDULE_BY_CUSTOMER',
                'RESCHEDULE_BY_RIDER',
              ],
              sortOrder: "desc",
                    sortBy: "id",
        };

        const data3 = {
          startDate: localeDateStartDate(new Date(selectedStatus?.newSchedular?.startDate)) || localeDateStartDate(new Date(startDate)),
          endDate: localeDateEndDate(new Date(selectedStatus?.newSchedular?.endDate)) || localeDateEndDate(new Date(endDate)),
          jobStatus: ['CANCEL_BY_RIDER',
            'CANCEL_BY_CUSTOMER',
            'CANCEL_BY_STORE'],
            sortOrder: "desc",
                  sortBy: "id",
            
        };

        if (selectedStatus?.newSchedular?.selectedStatus === "ORDER_BOOKED") {
          fetchRiderJobPickupData(data1, storeId);
        } else if (selectedStatus?.newSchedular?.selectedStatus === "ORDER_CANCEL") {
          fetchRiderJobPickupData(data3, storeId);
        } else {
          fetchRiderJobPickupData(data2, storeId);
        }

        setIsGetJobButtonPressed(false);
        fetchSelectedTabListView();

        // Reset the form fields
        let initialStartDate = new Date();
        setStartDate(new Date(initialStartDate));

        let initialEndDate = new Date();
        // Set the minimumDate for the end date picker
        setEndDate(initialEndDate);
      }, 1000); // Replace with actual async operation duration
    }
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i className="pi pi-angle-left" onClick={() => navigate(-1)} style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold ">
                Pickup Job
              </p>
            </div>
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer mr-3"
            onClick={() => navigate("/PickupJobForm")}
          >
            <p className=" text-2xl text-white font-bold capitalize mr-3">Add New Pickup</p>
            <div className="flex justify-content-center align-items-center relative bg-white border-circle shadow-4 align-self-center">
              <img
                style={{
                  position: "relative",
                  top: "-5px",
                  width: height < 600 ? "30px" : "40px",
                }}
                src="/Laundy_App_Icons_Gifs/Customer_Info_GIFs/Pickup_Request.gif"
                alt="logo"
              />
            </div>
          </div>

          {storeId &&
            <>
              <div
                className="flex justify-content-center align-items-center cursor-pointer"
                onClick={() => {
                  tabularView !== "tab"
                    ? handleTabListViewChange("tab")
                    : handleTabListViewChange("list");
                }}
              >
                <div
                  className="px-3 py-1 cursor-pointer"
                  style={{
                    backgroundColor: "#55BD5A",
                    borderRadius: 5,
                    marginRight: 20,
                  }}
                >
                  <p className=" text-lg text-white font-medium capitalize">
                    {tabularView !== "tab" ? "Tab View" : "List View"}
                  </p>
                </div>
              </div>



              <div
                className="flex justify-content-center align-items-center cursor-pointer"
                onClick={() => {
                  handleFilterOrderBookedModal();
                }}
              >
                <div
                  className="px-3 py-1 cursor-pointer"
                  style={{
                    backgroundColor: "#50c8cc",
                    borderRadius: 5,
                    marginRight: 20,
                  }}
                >
                  <p className=" text-lg text-white font-medium capitalize">
                    Closed Pickup
                  </p>
                </div>
              </div>

            <div
              className="flex justify-content-center align-items-center cursor-pointer"
              onClick={() => {
                handleFilterOrderCancelModal();
              }}
            >
              <div
                className="px-3 py-1 cursor-pointer"
                style={{
                  backgroundColor: "red",
                  borderRadius: 5,
                  marginRight: 20,
                }}
              >
                <p className=" text-lg text-white font-medium capitalize">
                  Cancel Pickup
                </p>
              </div>
            </div>

              <div
                onClick={() => handleFilterModal("DELIVERED")}
                className="mx-2 cursor-pointer"
              >
                <img
                  src={"Laundy_App_Icons_Gifs/Other_Icons/filter.png"}
                  style={{ width: height < 600 ? 25 : 30 }}
                />
              </div>
            </>
          }


          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "30px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>


      <div className="flex flex-row">
        <div className="mt-4 mb-3 mx-4 flex-1">
          <FloatLabel>
            <Dropdown
              id="assignStoreValue"
              value={assignStoreValue}
              onChange={(e) => handleAssignStoreChange(e.target.value)}
              options={storeData}
              optionLabel="name"
              placeholder="Store"
              className="w-full border-round-xl  text-2xl text-xl shadow-2"
            />
            <label
              htmlFor="assignStoreValue"
              className="text-md"
              style={{ color: "blue" }}
            >
              Store <span style={{ color: "red" }}>*</span>
            </label>
          </FloatLabel>
        </div>
      </div>


      <SuccessModal
        setModalVisible={setModalVisible}
        modalVisible={modalVisible}
        status={'Added'}
        text={'Your Amount is added successfully.'}
      />
      <StatusFilterModal
        setStatusFilterModalVisible={setStatusFilterModalVisible}
        statusFilterModalVisible={statusFilterModalVisible}
        sendDataToOrdersPageFromFilter={receiveDataFromStatusFilterModal}
        upDateSelectedStatus={upDateSelectedStatus}
        OrderStatus={[
          "ORDER_BOOKED",
          "CANCEL_BY_RIDER",
        "CANCEL_BY_CUSTOMER",
        "CANCEL_BY_STORE",
          'PICKUP_REQ',
          'ASSIGNED_TO_RIDER',
          'RESCHEDULE_BY_CUSTOMER',
          'RESCHEDULE_BY_RIDER',
        ]}
      />


      <RiderPickupDeliveryOrderBookingModal
        setRiderPickupDeliveryOrderBookingModalVisible={setRiderPickupDeliveryOrderBookingModalVisible}
        riderPickupDeliveryOrderBookingModalVisible={riderPickupDeliveryOrderBookingModalVisible}
        sendDataToOrdersPageFromFilter={receiveDataFromOrderBookedFilterModal}
        upDateSelectedStatus={upDateSelectedStatus}
        OrderStatus={[
          "ORDER_BOOKED",
          "CANCEL_BY_RIDER",
        "CANCEL_BY_CUSTOMER",
        "CANCEL_BY_STORE",
          'PICKUP_REQ',
          'ASSIGNED_TO_RIDER',
          'RESCHEDULE_BY_CUSTOMER',
          'RESCHEDULE_BY_RIDER',
        ]}
      />

      <RiderPickupDeliveryOrderCancelModal
        setRiderPickupDeliveryOrderCancelModalVisible={setRiderPickupDeliveryOrderCancelModalVisible}
        riderPickupDeliveryOrderCancelModalVisible={riderPickupDeliveryOrderCancelModalVisible}
        sendDataToOrdersPageFromFilter={receiveDataFromOrderCancelFilterModal}
        upDateSelectedStatus={upDateSelectedStatus}
        OrderStatus={[
          "ORDER_BOOKED",
          "CANCEL_BY_RIDER",
        "CANCEL_BY_CUSTOMER",
        "CANCEL_BY_STORE",
          'PICKUP_REQ',
          'ASSIGNED_TO_RIDER',
          'RESCHEDULE_BY_CUSTOMER',
          'RESCHEDULE_BY_RIDER',
        ]}
      />

      <div>
        {tabularView === "tab" && (
          <div
            className="scroll-bar mb-2"
            style={{
              // height: height - 80,
              overflowY: "scroll",
            }}
          >
            {isLoading ? (
              <div style={{ flex: 1 }}>
                <div className="text-center">
                  <ProgressSpinner
                    style={{ width: "70px", height: "70px" }}
                    strokeWidth="4"
                    fill="var(--surface-ground)"
                    animationDuration="2s"
                  />
                </div>
              </div>) : (

              <JobRequestsListView
                orderInfoData={todayOrderData}
                JobType={jobType}
                storeId={storeId}
                callRequestApi={callRequestApi}
                pickupType={orderBookedType}
              />
            )}
          </div>
        )}
      </div>
      <div style={{ display: tabularView === "tab" ? "none" : "" }}>
        <JobRequests
          orderInfoData={todayOrderData}
          JobType={jobType}
          storeId={storeId}
          callRequestApi={callRequestApi}
        />
      </div>

      {/* <TabMenu  /> */}
      {userRole === "BY_SUPPORT_ADMIN" ? 
        <SupportAdminMenu setVisible={setVisible} visible={visible} />
        :
        <AdminMenu setVisible={setVisible} visible={visible} />
      }
      
      <ButtonLink />
      <audio
        ref={audioRef}
        preload="auto"
        // src="https://qdc-static-assets.s3.ap-south-1.amazonaws.com/pickup-notifications/ding.mp3"
        src={PickupNotification}
      />
      <div className="flex justify-content-center">
        <Toast ref={toast} />
      </div>
    </div>
  );
};

export default PickupJobAdmin;